import React, { useState } from "react";
import BackgroundImage from "gatsby-background-image";
import { graphql, useStaticQuery, navigate, Link as GatsbyLink } from "gatsby";
import { useMediaQuery } from "react-responsive";
import { Modal, ModalHeader, ModalBody } from "reactstrap";
import Logo from "../../assets/aia-logo";
import MailTo from "../../context/mailto";
import CourseRegistrationForm from "../../components/product-detail/CourseRegistration/courseRegistrationForm";
import "./banner.scss";
import data from "../../assets/data.json";

const TitleBanner = (props) => {
  const {
    id,
    title,
    description,
    duration,
    netFee,
    price,
    days,
    courseRuns,
    coverPhoto,
  } = props;

  const isMobile = useMediaQuery({ query: "(max-width: 565px)" });
  const [modal, setModal] = useState(false);
  const toggle = () => setModal(!modal);

  const toNum = (v) => {
    const n = typeof v === "number" ? v : Number(v);
    return Number.isFinite(n) ? n : 0;
  };
  const fmtSGD = (n) =>
    `S$${toNum(n).toLocaleString("en-SG", {
      minimumFractionDigits: 2,
      maximumFractionDigits: 2,
    })}`;

  const priceN = toNum(price);
  const isFree = priceN === 0;
  const hasPrice = price !== undefined && price !== null && price !== "";

  // Fetch banner background images
  const bannerImage = useStaticQuery(graphql`
    query {
      background1: file(relativePath: { eq: "innerpage-bg-new.jpg" }) {
        childImageSharp {
          fluid(quality: 100, maxWidth: 1920) {
            ...GatsbyImageSharpFluid
          }
        }
      }
      background2: file(relativePath: { eq: "contact-bg.png" }) {
        childImageSharp {
          fluid(quality: 100, maxWidth: 1920) {
            ...GatsbyImageSharpFluid
          }
        }
      }
    }
  `);
  const BannerBGImage1 = bannerImage.background1.childImageSharp.fluid;
  const BannerBGImage2 = bannerImage.background2.childImageSharp.fluid;

  return (
    <>
      <BackgroundImage className="innerPageBanner" fluid={BannerBGImage1}>
        <div className="container">
          <div className="innerPageContent">
            <h1 className="innerPageTitle">{title}</h1>
            <p className="sliderDescription">{description}</p>

            {/* Action Buttons */}
            <div className="innerPageContentForm">
              <div className="actionBtns">
                <button className="btnRegister" onClick={() => MailTo()}>
                  Enquire Now
                </button>
                {id === "f04d4a66-08d4-5e23-a009-825daf2985bb" ? null : (
                  <a href={courseRuns}>
                    <button className="btnSkilleto">Register</button>
                  </a>
                )}
              </div>
            </div>

            {/* Course Info Section */}
            <div className="innerPageCourseDetails">
              {/* Location */}
              <div className="detailItem">
                <div className="detailText">
                  <h4>Location</h4>
                  <p>
                    <em>{data.address}</em>
                  </p>
                </div>
              </div>

              {/* Duration */}
              {duration && (
                <div className="detailItem">
                  <div className="detailText">
                    <h4>Duration</h4>
                    <p>
                      <em>
                        {" "}
                        {days} Day(s) <br />({duration} Hours)
                      </em>
                    </p>
                  </div>
                </div>
              )}

              {/* Fee */}
              {hasPrice && (
                <div className="detailItem">
                  <div className="detailText">
                    <h4
                      className="course-fee-heading"
                      title="Click to view course fee details"
                      onClick={() => {
                        const section = document.getElementById(
                          "course-fee-section"
                        );
                        if (section) {
                          const yOffset = -140;
                          const y =
                            section.getBoundingClientRect().top +
                            window.pageYOffset +
                            yOffset;
                          window.scrollTo({ top: y, behavior: "smooth" });
                        }
                      }}
                    >
                      Course Fee
                      <span className="arrow-icon">⤵</span>
                    </h4>

                    <p>
                      <em>
                        {isFree ? (
                          <>FOC</>
                        ) : (
                          <>
                            {fmtSGD(priceN)} <br />
                            <span className="spanGst">(excluding GST)</span>
                          </>
                        )}
                      </em>
                    </p>
                  </div>
                </div>
              )}

              {/* Skill Level */}
              <div className="detailItem">
                <div className="detailText">
                  <h4>Skill Level</h4>
                  <p>
                    <em>Beginner</em>
                  </p>
                </div>
              </div>
            </div>
          </div>
        </div>
      </BackgroundImage>

      {/* Registration Modal */}
      <div>
        <Modal isOpen={modal} toggle={toggle}>
          <ModalHeader toggle={toggle}>
            <GatsbyLink to="/">
              <Logo />
            </GatsbyLink>
          </ModalHeader>
          <ModalBody>
            <CourseRegistrationForm
              price={netFee}
              selectedCourse={title}
              coverPhoto={coverPhoto}
            />
          </ModalBody>
        </Modal>
      </div>
    </>
  );
};

export default TitleBanner;
